<div class="card-payment">
  <div class="card-payment-header">{{ header | translate }}</div>
  <div class="card-payment-hint">{{ hint | translate : { referenceNumber: referenceNumber } }}</div>
  <ng-template [ngIf]="isLateEntry">
    <div class="card-payment-hint" [innerHTML]="'LABELS.LATE_ENTRY_HINT' | translate"></div>
  </ng-template>
  <div class="card-payment-content">
    <ng-template ngFor [ngForOf]="paymentGroupItems" let-paymentGroupItem>
      <div [class.card-payment-item-group]="paymentGroupItem.discountGroupId">
        <div
          class="card-payment-item"
          [ngClass]="{ header: paymentItem.type === 'header' }"
          *ngFor="let paymentItem of paymentGroupItem.items"
        >
          <div class="card-payment-item-header" [ngClass]="{ 'line-through': paymentItem.priceType === 'canceled' }">
            <span>
              {{
                (paymentItem.header | translate) +
                  (paymentItem.quantity > 1 ? " (x" + paymentItem.quantity + ")" : "") +
                  (paymentItem.type === "header" ? ":" : "")
              }}
            </span>
            <ng-template [ngIf]="paymentItem.notes">: {{ paymentItem.notes }}</ng-template>
          </div>
          <div *ngIf="paymentItem.price !== null && paymentItem.price !== undefined" class="card-payment-item-price">
            <span class="canceled" *ngIf="paymentItem.priceType === 'canceled'">{{ "STATUS_MANUAL.CANCELED" | translate }}</span>
            <span [ngClass]="{ 'line-through': paymentItem.priceType === 'canceled' }">
              {{ paymentItem.quantity * paymentItem.price | currency : "USD" : "symbol" : "1.2-2" }}
            </span>
          </div>
          <div *ngIf="paymentItem.hint" class="card-payment-item-hint" [innerHTML]="'*' + (paymentItem.hint | translate)"></div>
        </div>
      </div>
    </ng-template>
    <div class="card-payment-total">
      <div class="card-payment-item-header">
        {{ paymentTotalHeader | translate }}
      </div>
      <div class="card-payment-item-price">{{ paymentTotalPrice | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}</div>
    </div>
    <div class="card-payment-action-container">
      <ng-content></ng-content>
    </div>
  </div>
  <div *ngIf="footer" class="card-payment-footer">{{ footer | translate }}</div>
</div>
